/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/string/OnlyContains.ts
 * @create:      2025-06-26 10:03:21.141
 * @modify:      2025-07-11 21:19:12.849
 * @version:     6.0.0
 * @times:       14
 * @lines:       67
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { Strings_Empty } from "../const/Strings";
import { StringDistinct } from "./StringDistinct";

/**
 * Determines whether the given string consists only of the specified characters.
 *
 * @param str - The string to check.
 * @param characters - The list of allowed characters. The string is valid only if every character in `str` is present in this list.
 * @returns `true` if `str` contains only the specified characters or is empty; otherwise, `false`.
 *
 * @remarks
 * - The function removes duplicate characters from the `characters` list before checking.
 * - If `str` is empty, the function returns `true`.
 * 
 * @since 4.0.0
 * @version 2025-07-09
 */
export function OnlyContains(
    str: string,
    ...characters: string[]
) {
    if (str.length === 0) {
        return true;
    }
    
    const charactersStr = StringDistinct(characters.join(Strings_Empty));
    for (const val of str) {
        if (!charactersStr.includes(val)) {
            return false;
        }
    }

    return true;
}
